export default {"src":"/_next/static/media/favicon-codeai.1192ba9d.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};